// extracted by mini-css-extract-plugin
export default {"report-shell":"ELuHeLzZU6KhazcltqkT"};